import { Captura, Section } from "./comunes";

/** Ayuda del catálogo de Ventas: qué es, cómo buscar y cómo cargar el
 * archivo mensual (solo admin). */
export default function AyudaVentas({ esAdmin }: { esAdmin: boolean }) {
  return (
    <Section id="ventas" title="Ventas — equipos vendidos">
      <p>
        <strong>Ventas</strong> es la lista de ventas del CRM de Emprenet,
        buscable desde ArkTickets. Sirve para lo que antes no se podía hacer
        rápido: comprobar si un equipo <strong>lo vendimos nosotros</strong>{" "}
        antes de dar soporte — a quién se vendió, cuándo y con qué cotización.
      </p>
      <ul className="list-disc list-inside space-y-1">
        <li>
          <strong>Busca por lo que tengas</strong>: un IMEI, una empresa, el
          nombre del contacto, un número de cotización, un serial de cámara o
          un modelo. La búsqueda ignora acentos y mayúsculas.
        </li>
        <li>
          <strong>Haz clic en una venta</strong> para ver su detalle: el
          contacto, la cotización y todos los números del equipo (IMEIs,
          seriales, SIMs), copiables de un clic. El número que buscaste
          aparece resaltado.
        </li>
        <li>
          Si un IMEI sale en <strong>dos ventas</strong>, es su historial: la
          venta original y su garantía. Las garantías traen la etiqueta{" "}
          <strong>Garantía</strong> y marcan qué equipo llegó con falla y cuál
          lo reemplazó.
        </li>
        <li>
          Si un equipo <strong>no aparece</strong>, probablemente no lo
          vendimos nosotros. Ojo: revisa la fecha de «última carga» arriba —
          el mes en curso puede no estar cargado todavía.
        </li>
        <li>
          <strong>Aviso al capturar IMEIs en un caso</strong>: al escribir
          IMEIs en «Nuevo caso» o al agregarlos a un caso, la app los cruza
          sola contra este catálogo. Si alguno no aparece, verás un aviso
          ámbar con el número ligado a su búsqueda — <strong>es solo un
          aviso, nunca te impide continuar</strong>. En la pestaña de IMEIs
          del caso, cada equipo trae su marca «✓ ventas» o «⚠ sin venta».
        </li>
      </ul>
      <Captura
        src="/ayuda-img/ventas-imei-garantia.png"
        alt="Búsqueda de un IMEI que aparece en su venta original y en su garantía"
        caption="Un IMEI con historial: su garantía (con el equipo con falla y el nuevo) y su venta original."
      />
      <Captura
        src="/ayuda-img/ventas-movil.png"
        alt="Vista de Ventas en el celular con los seriales de una venta"
        caption="En el celular: cada venta es una tarjeta; tócala para ver sus números."
      />
      {esAdmin && (
        <>
          <p className="pt-1">
            <strong>Cargar el archivo (solo admin).</strong> Con «Subir
            archivo» subes el Excel que manda el CRM tal cual llega, sin
            editarlo. Puedes subir el histórico completo cada mes sin miedo:
            lo ya cargado <strong>no se duplica</strong>. Al terminar verás
            cuántas ventas nuevas entraron.
          </p>
          <p>
            En «Cargas» está el historial de archivos subidos. Si un archivo
            salió mal, <strong>Revertir</strong> borra solo las ventas que esa
            carga metió como nuevas — las demás no se tocan — y puedes volver
            a subir el archivo correcto.
          </p>
          <Captura
            src="/ayuda-img/ventas-modal-subir.png"
            alt="Ventana para subir el Excel de ventas"
            caption="Arrastra el Excel del CRM o haz clic para elegirlo."
          />
        </>
      )}
    </Section>
  );
}
